<template>
  <div>
    <v-list>
      <ListItem
        :title="user.id"
        :subtitle="$t('fields.id')"
      />
      <ListItem
        :title="user.name"
        :subtitle="$t('fields.name')"
      />
      <ListItem
        :title="user.surname"
        :subtitle="$t('fields.surname')"
      />
      <ListItem
        :title="user.phone"
        :subtitle="$t('fields.phone')"
      />
      <ListItem
        :title="user.email"
        :subtitle="$t('fields.email')"
      />
    </v-list>
  </div>
</template>

<script>
  import { mapActions } from 'vuex';

  import ListItem from '../../shared/Lists/ListItem';

  export default {
    name: 'UserDetails',
    components: { ListItem },
    props: {
      user: {
        type: Object,
        default: () => {},
      },
    },
    methods: {
      ...mapActions('confirm', ['showConfirm']),
      ...mapActions('alert', ['showToast']),
    },
  };
</script>
